import React, { useCallback, useEffect, useState } from "react";
import { getQuestions, updateLastAnswer } from "../utils/firebase.actions";
import { Questions } from "../utils/types";
import CustomWebCam from "../components/CustomWebCam";
import firebase from "firebase";
import { getJsonValue } from "../utils/localstorage.util";
import { convertDataUrlToBlob } from "../utils";

import GameResult from "../components/GameResult";
import Loader from "../components/Loader";
import useQuestions from "../hooks/useQuestions";
import useTimer from "../hooks/useTimer";

export default function Game() {
  const [questions, setQuestions] = useQuestions();
  const timer = useTimer();
  const [currentQuestion, setCurrentQuestion] = useState<Questions>();
  const [isGameEnd, setGameEnd] = useState<boolean>(false);
  const [isCameraOpen, setCameraOpen] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(true);
  const getRandomQuestion = useCallback(() => {
    const unAnsweredQuestions = questions.filter((q) => !q.isAnswer);
    if (questions.length && !unAnsweredQuestions.length) {
      setGameEnd(true);
    }
    setCurrentQuestion(
      unAnsweredQuestions[
        Math.floor(Math.random() * unAnsweredQuestions.length)
      ]
    );
  }, [questions, currentQuestion]);

  const uploadImage = useCallback(
    (imageSrc: any) => {
      setLoading(true);
      const team = getJsonValue("TEAM");
      const storageRef = firebase
        .storage()
        .ref(`teams/${team.id}/${currentQuestion?.id}/answer.png`);
      const uploadTask = storageRef.put(convertDataUrlToBlob(imageSrc));
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
        },
        (error) => {
          console.error("Error uploading file:", error);
          setLoading(false);
        },
        async () => {
          setCameraOpen(false);
          setQuestions((prev) => {
            const updatedQuestions = [...prev];
            const currentQuestionIndex = updatedQuestions.findIndex(
              (q) => q.id === currentQuestion?.id
            );
            if (currentQuestionIndex !== -1) {
              updatedQuestions[currentQuestionIndex].isAnswer = true;
            }
            return updatedQuestions;
          });
          await updateLastAnswer(team.id);
          setLoading(false);
        }
      );
    },
    [currentQuestion, questions]
  );

  const discard = useCallback(() => {
    setCameraOpen(false);
  }, []);

  useEffect(() => {
    getRandomQuestion();
    setLoading(false);
  }, [questions]);

  return (
    <section className="game-container">

      {isLoading && (
        <Loader message={isCameraOpen ? "Preparing next question..." : ""} />
      )}
      {!isGameEnd && currentQuestion && (
        <article className="question-container">
          <span>{timer}</span>
          <h2>{currentQuestion?.value}</h2>
          <i
            className="fa-solid fa-camera"
            onClick={() => {
              setCameraOpen(true);
            }}
          ></i>
        </article>
      )}
      {isCameraOpen && (
        <CustomWebCam uploadImage={uploadImage} discard={discard} />
      )}
      {isGameEnd && <GameResult />}
    </section>
  );
}
